var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import { raScreenXsMax, raScreenSm, raScreenSmMax, raScreenMd, raScreenMdMax, raScreenLg, raScreenLgMax, raScreenXl } from "@riseart/antd-provider/dist/website/variables.less";
import { MediaQuery } from "../../responsive/MediaQuery";
import { preloaderFallbackCls } from "./Fallback.less";
var bpList = {
  xs: {
    maxWidth: raScreenXsMax
  },
  sm: {
    minWidth: raScreenSm,
    maxWidth: raScreenSmMax
  },
  md: {
    minWidth: raScreenMd,
    maxWidth: raScreenMdMax
  },
  lg: {
    minWidth: raScreenLg,
    maxWidth: raScreenLgMax
  },
  xl: {
    minWidth: raScreenXl
  }
};
var PreloaderContentFallback = /* @__PURE__ */ __name(function PreloaderContentFallback2(_ref) {
  var _ref$common = _ref.common, common = _ref$common === void 0 ? null : _ref$common, _ref$xs = _ref.xs, xs = _ref$xs === void 0 ? null : _ref$xs, _ref$sm = _ref.sm, sm = _ref$sm === void 0 ? null : _ref$sm, _ref$md = _ref.md, md = _ref$md === void 0 ? null : _ref$md, _ref$lg = _ref.lg, lg = _ref$lg === void 0 ? null : _ref$lg, _ref$xl = _ref.xl, xl = _ref$xl === void 0 ? null : _ref$xl;
  var propsByBreakpoint = [{
    key: "xs",
    styles: xs
  }, {
    key: "sm",
    styles: sm
  }, {
    key: "md",
    styles: md
  }, {
    key: "lg",
    styles: lg
  }, {
    key: "xl",
    styles: xl
  }].reduce(function(result, i) {
    if (i && i.styles) {
      result.push({
        key: i.key,
        mediaQueryProps: bpList[i.key],
        styles: _objectSpread(_objectSpread({}, common), i.styles)
      });
      return result;
    }
    return result;
  }, []);
  if (propsByBreakpoint.length) {
    return /* @__PURE__ */ React.createElement(MediaQuery, {
      minWidth: 0
    }, propsByBreakpoint.map(function(props, idx) {
      var maxWidth = idx < propsByBreakpoint.length - 1 ? props.mediaQueryProps.maxWidth : null;
      var minWidth = idx > 0 ? props.mediaQueryProps.minWidth : null;
      var mediaQueryProps = _objectSpread(_objectSpread({}, minWidth ? {
        minWidth
      } : null), maxWidth ? {
        maxWidth
      } : null);
      return /* @__PURE__ */ React.createElement(MediaQuery, _extends({
        key: props.key
      }, mediaQueryProps), /* @__PURE__ */ React.createElement("div", {
        className: preloaderFallbackCls,
        style: props.styles
      }));
    }));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: preloaderFallbackCls,
    style: common
  });
}, "PreloaderContentFallback");
export {
  PreloaderContentFallback
};
